import styled from '@emotion/styled'

import { LinkButton } from '../../atoms'

export const Wrapper = styled.div`
  background-color: var(--White);
  display: grid;
  grid-template-rows: 0 81px auto;
  opacity: 1;
`

export const ProgressBar = styled.hr<{ percent: number }>`
  border-top: solid 3px var(--Red-Dark);
  border-right: none;
  border-bottom: none;
  border-left: none;
  width: ${props => props.percent}%;
  margin-top: 78px;
  margin-left: 0;
  padding: 0;
  z-index: 2000;
`

export const ProgressNumbers = styled.div`
  margin-left: auto;
  margin-right: 8px;
  color: var(--White60);
  font-size: 14px;
`

export const Header = styled.div`
  align-items: center;
  background-color: var(--White96);
  border-radius: 4px 4px 0 0;
  border-bottom: 1px solid var(--White96);
  padding: 0;
  display: flex;
  justify-content: flex-start;
  position: relative;
`

export const CurrentStepNumber = styled.span`
  color: var(--Graphite);
`

export const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  flex: 0 1 auto;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
`

export const Title = styled.h1`
  font-size: 14px;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: unset;
`

export const StyledLink = styled(LinkButton)`
  display: flex;
  align-items: center;
  padding: 0 36px;
  font-size: 11px;
  text-transform: uppercase;
  font-weight: lighter;
  flex: 0 1 auto;
  margin-left: auto;
`
